import { autoInjectable } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { ofType } from 'deox';
import { OverlayService } from '../services/overlay/overlay.service';
import { Analytics } from '../modules/analytics/analytics';
import { CommonEffect } from './common-effect';
import { OverlayActions } from '../actions';
import { concatMap, exhaustMap, map, tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { PublicEventEmitterService } from '../services/public-event-emitter/public-event-emitter.service';
import { createScopedAction } from '../util/actions/action-mod.util';

@autoInjectable()
export class OverlayEffects implements CommonEffect {

  /**
   * Show overlay action
   */
  showOverlay$ = this.store.actions$.pipe(
    ofType(OverlayActions.showOverlay),
    exhaustMap((placementAction) => {
      return this.overlayService.showOverlayContent(
        placementAction.payload.actionContentId,
        placementAction.payload.placementConfig,
        placementAction.payload.brandPresentmentConfig,
        placementAction.payload.placementMetaData
      );
    })
  );

  showOverlayAuxEvent$ = this.store.actions$.pipe(
    ofType(OverlayActions.showOverlayAuxEvent),
    map(()=>createScopedAction({
        type: 'SHOW_OVERLAY',
      }, 'EPJS')
    ),
    tap((action)=>
      this.publicEventEmitterService.emitter.emit(
        action.type, action.payload
      )
    )
  );

  /**
   * Close overlay
   */
  closeOverlay$ = this.store.actions$.pipe(
    ofType(OverlayActions.closeOverlay),
    map(action=>action.payload),
    exhaustMap(({dismissTarget}) =>
      this.overlayService.dismissOverlay(dismissTarget)
    ),
  );

  setOverlayDisposeLock$ = this.store.actions$.pipe(
    ofType(OverlayActions.setOverlayDisposeLock),
    map(action=>action.payload),
    concatMap(({lockOverlay, dismissTarget})=>
      this.overlayService.setOverlayDisposeLock(lockOverlay, dismissTarget)
    )
  );

  publicEvents$ = this.store.actions$.pipe(
    ofType([OverlayActions.closeOverlay, OverlayActions.showOverlay]),
    map(action => createScopedAction(action, 'EPJS')),
    tap((action)=>
      this.publicEventEmitterService.emitter.emit(
        action.type, action.payload
      )
    )
  );

  breadApply$ = this.store.actions$.pipe(
    ofType(OverlayActions.breadApply),
  );



  constructor(private store?: EpStore,
              private overlayService?: OverlayService,
              private publicEventEmitterService?: PublicEventEmitterService,
              private analytics?: Analytics) {
  }

  bindSideEffects() {
    return merge(
      this.showOverlay$,
      this.closeOverlay$,
      this.publicEvents$,
      this.showOverlayAuxEvent$,
      this.breadApply$,
      this.setOverlayDisposeLock$,

    ).subscribe();
  }

}
